
//! bunun value larını 1,2,3,4,5 olarak yap, diğer yerlerde sıkıntı olup olmamasını kontrol et
const odemeSekliOptions = [
      {
        value: 1,
        text: "Peşin",
      },
      {
        value: 2,
        text: "Kredi Kartı",
      },
      {
        value:  3,
        text: "Karşı Ödemeli",
      },
      {
        value:  4,
        text: "Havale",
      },
      {
        value:  5,
        text: "Havale(7gün)",
      },
      {
        value: 6,
        text: "Havale(14gün)",
      },
      {
        value:  7,
        text: "Nakit + Yakıt",
      },
      {
        value:  8,
        text: "Yakıt",
      },
      {
        value:  9,
        text: "Diğer",
      }
]

export default odemeSekliOptions
